// extracted by mini-css-extract-plugin
export default {"closeBtn":"CloseBtn_closeBtn__xejGG"};